module.exports = __webpack_public_path__ + "assets/images/shop2.0e74187f.jpg";